export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14689.68046e65.jpg";